import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IGenericObject } from 'shared/models/Common'

type ModalAction = {
  type: string
  data?: IGenericObject | null
  overrideType?: boolean
}

const initialState = {
  open: false as boolean,
  type: undefined as string | undefined,
  data: null as IGenericObject | null,
}

export type ModalState = typeof initialState

const reducer = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalAction | undefined>) => {
      if (state.type && !action.payload?.overrideType) return state

      state.type = action.payload?.type
      state.data = action.payload?.data || null

      state.open = true
    },
    closeModal: (state: ModalState) => {
      state.open = false
      state.type = undefined
      state.data = null
    },
  },
})

export default reducer
export const actions = reducer.actions
